import { BREAKPOINTS } from '../constants/FRNBaseStyles';

/**
 * This function add actions when an element is out of view and back to view after scrolling window
 * @param {DOM element} element - the DOM element to check the visibility after scrolling
 * @param {double} ratio - the out-of-view ratio part of the DOM element for it to be marked as invisible - 1 by default
 * @param {int} delta - adjustment in pixel - 0 by default
 * @param {function} scrollDownCallback - callback function when the DOM element is not visible after scrolling down
 * @param {function} scrollUpCallback - callback function when the DOM element is visible again after scrolling up
 */
const onScroll = ({ element, ratio = 1, delta = 0 }, scrollDownCallback, scrollUpCallback) => {
  if (window && element) {
    const onScrollListener = () => {
      const $ = window['$'];

      /** When window scrolls over ratio * height of the element */
      if ((element.offsetHeight * ratio + $(element).offset().top + delta) <= $(window).scrollTop()) {
        if (scrollDownCallback) {
          scrollDownCallback();
        }
      } else {
        if (scrollUpCallback) {
          scrollUpCallback();
        }
      }
    };

    window.addEventListener('scroll', onScrollListener);

    return onScrollListener;
  }
};

const offScroll = (eventListener) => {
  if (window && eventListener) {
    window.removeEventListener('scroll', eventListener);
  }
};

const showWindow = (url = '', target = '_blank', data = {}) => {
  let windowOption = '';
  Object.keys(data).map((key) => {
    windowOption += `${key}=${data[key]},`;
  });
  return open(url, target, windowOption.slice(0, -1));
};

const getDataOfWindowOpen = (widthWindow, heightWindow, showToolbar, showScrollbar, showLocation, isResizable) => {
  return {
    width: widthWindow,
    height: heightWindow,
    toolbar: showToolbar,
    scrollbars: showScrollbar,
    location: showLocation,
    resizable: isResizable,
    left: '400'
  };
};

const getCurrentWindowBreakpointSize = () => {
  const windowWidth = window.innerWidth;
  let currentWindowBreakpointSize;

  for (let i = 0; i < BREAKPOINTS.length; i++){
    if (BREAKPOINTS[i].minWidth <= windowWidth) {
      if (i + 1 === BREAKPOINTS.length || BREAKPOINTS[i + 1].minWidth > windowWidth) {
        currentWindowBreakpointSize = BREAKPOINTS[i].size;
        break;
      }
    }
  }

  return currentWindowBreakpointSize;
}

export { onScroll, offScroll, showWindow, getDataOfWindowOpen, getCurrentWindowBreakpointSize };



// WEBPACK FOOTER //
// ./app/utils/WindowUtils.js